import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 16a1 1 0 0 1 .29-.71l9-9a1 1 0 0 1 1.42 0l9 9a1.003 1.003 0 1 1-1.42 1.42L12 8.41l-8.29 8.3A1.001 1.001 0 0 1 2 16"
    />
  </svg>
);
export default SvgChevronUp;
